import { useContext } from 'react';
import {
  CardPrintContext,
  MOBILE_CARD_PRINT_TRAY_STRIP_HEIGHT_PX,
  type CardPrintContextValue,
} from './CardPrintContext';

export function useCardPrint(): CardPrintContextValue {
  const ctx = useContext(CardPrintContext);
  if (!ctx) {
    throw new Error('useCardPrint must be used within CardPrintProvider');
  }
  return ctx;
}

/** Extra FAB lift from the tray strip when card-print has items in tray (mobile). */
export function useCardPrintMobileFabInsetPx(): number {
  const ctx = useContext(CardPrintContext);
  if (!ctx) return 0;
  return ctx.trayTotalQty > 0 ? MOBILE_CARD_PRINT_TRAY_STRIP_HEIGHT_PX : 0;
}
